import Vue from 'vue'
import Vuex from 'vuex'
import { userInfo } from "@/api/index";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    platformTitle: '虚拟云教具实训平台',
    login: false,
    me: null,
  },
  mutations: {
    SET_LOGIN(state, val) {
      state.login = val
      if (val) {
        this.dispatch('GET_USER_INFO')
      }
    },
    SET_STATE(state, obj) {
      if (Object.hasOwnProperty.call(state, obj.key)) {
        state[obj.key] = obj.value;
      }
    },
  },
  actions: {
    GET_USER_INFO({ commit }) {
      userInfo().then(({ data }) => {
        commit('SET_STATE', { key: 'me', value: data })
      })
    }
  },
  modules: {
  }
})
